import React from 'react';

import {Cell} from './Cell';
import type {ColumnDef} from '../types/ColumnDef';
import {Box} from '@mui/material';
import {DEFAULT_ROW_HEIGHT} from '../constant';

interface RowProps<T> {
  row: T;
  rowIndex: number;
  columns: ColumnDef<T>[];
  rowHeight?: number;
  onRowClick?: (row: T) => void;
  getRowClass?: (row: T) => string;
  dataTestId: string;
}

export function Row<T>({
  row,
  rowIndex,
  columns,
  rowHeight = DEFAULT_ROW_HEIGHT,
  onRowClick,
  getRowClass,
  dataTestId,
}: RowProps<T>) {
  const className = getRowClass ? getRowClass(row) : '';

  return (
    <Box
      className="lazy-grid-row-container"
      role="row"
      aria-rowindex={rowIndex}
      data-row-index={rowIndex}
      tabIndex={0}
    >
      <Box
        className={`lazy-grid-row ${className}`}
        onClick={() => onRowClick?.(row)}
        data-testid={dataTestId}
        sx={{
          height: rowHeight,
          cursor: onRowClick ? 'pointer' : 'default',
        }}
      >
        {columns.map((col, colIndex) => (
          <Cell
            key={col.field}
            row={row}
            rowIndex={rowIndex}
            colDef={col}
            colIndex={colIndex}
          />
        ))}
      </Box>
    </Box>
  );
}
